import { queryKeys } from '@/hooks/constants';
import { useMutationWithLogging } from '@/hooks/useMutationWithLogging';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import Service from '@/lib/App';

export function useGetProductEntities(
  searchTerm: string,
  offset: string,
  limit: string,
  options?: {
    [key: string]: any;
  },
) {
  const searchParams = {
    searchTerm,
    offset,
    limit,
  };

  return useQueryWithLogging({
    queryKey: queryKeys.planner.getProductEntities(searchTerm, offset),
    queryFn: () => {
      return Service.planner.getProductEntities(
        new URLSearchParams(searchParams).toString(),
      );
    },
    ...options,
  });
}

export function useCreateProductEntity(options?: { [key: string]: any }) {
  return useMutationWithLogging({
    mutationFn: (productEntityName: string) => {
      return Service.planner.createProductEntity({
        name: productEntityName,
      });
    },
    ...options,
  });
}

export function useDeleteProductEntity(options?: { [key: string]: any }) {
  return useMutationWithLogging({
    mutationFn: (productEntityName: string) => {
      return Service.planner.deleteProductEntity(productEntityName);
    },
    ...options,
  });
}
